// extracted by mini-css-extract-plugin
export default {"pageRoot":"LandingPage_pageRoot__JuwIM","sections":"LandingPage_sections__KuxY1"};